import React, { useEffect, useState } from 'react'
import request from "../../../utils/request";
import { Box } from '@mui/material';
import loader from '../../common/loader.gif';

function EndorsementMailPreview({ selectedEndorsement }) {
    const [previewHtml, setPreviewHtml] = useState<string | null>(null);
    const [previewLoading, setPreviewLoading] = useState<boolean>(false);
    useEffect(() => {
        fetchEndorsementPreview();
    }, [])

    const fetchEndorsementPreview = () => {
        setPreviewLoading(true);
        // const URL = 'endorsement/getMailPreviewBeforeCreate';
        const URL = 'endorsement/getEndorsementMailPreview'
        request({
            url: URL,
            method: 'POST',
            data: {
                showButton:false,
                type :"SharedToInsure",
                paymentType:selectedEndorsement?.paymentType??'CASH',
                insuranceCompanyId:selectedEndorsement?.insurancePolicy?.insuranceCompany?.id,
                insuranceCompanyBranchId:selectedEndorsement?.insurancePolicy?.insuranceCompanyBranch?.id,
                insuranceCompanyIds:[selectedEndorsement?.insurancePolicy?.insuranceCompany?.id??0],
                ids:[selectedEndorsement?.id],
                bankAccountId:selectedEndorsement?.bankAccountId

            }
        })
            .then((response: any) => {
                setPreviewLoading(false);

                setPreviewHtml(response);
            })
            .catch((err) => {
                // setShowSnackBarAlert({
                //     status: true,
                //     type: 'error',
                //     message: err.message
                // });
                setPreviewLoading(false);
            });
    }
    return (
        <div>  {previewLoading ? <div style={{ textAlign: 'center' }}>
            <img
                alt="loader"
                src={loader}
                className="loader"
                width={100}
                height={100}
            />
        </div> : (<>
            {previewHtml && (
                <Box
                    sx={{
                        width: '100%',
                        height: 'calc(100vh - 120px)',
                        border: '1px solid #ddd',
                        mt: 2
                    }}
                >
                    <iframe
                        title="Endorsement Preview"
                        srcDoc={`
                                             <!DOCTYPE html>
                                             <html>
                                               <head>
                                                 <meta charset="utf-8" />
                                                 <style>
                                                   html, body {
                                                     margin: 0;
                                                     padding: 0;
                                                     width: 100%;
                                                     height: 100%;
                                                   }
                                                   * {
                                                     box-sizing: border-box;
                                                   }
                                                 </style>
                                               </head>
                                               <body>
                                                 ${previewHtml}
                                               </body>
                                             </html>
                                           `}
                        style={{
                            width: '100%',
                            height: '100%',
                            border: 'none'
                        }}
                    />
                </Box>
            )}
        </>)}</div>
    )
}

export default EndorsementMailPreview